'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var legend = {
    enabled: true,
    itemStyle: {
        font: '15px "TT Commons", Arial, sans-serif',
    },
};
var credits = {
    enabled: false,
};
var title = {
    text: '',
};
var chartType = {
    type: 'area',
    plotBorderWidth: 0,
    backgroundColor: 'rgba(0,0,0,0)',
};
var goalSeries = {
    showInLegend: true,
    data: [0],
    lineWidth: 2,
    dashStyle: 'shortdot',
    fillColor: 'rgba(0,0,0,0)',
    enableMouseTracking: false,
};
var xAxisDefaults = {
    min: 0.3,
    minorTickInterval: null,
    gridLineWidth: 0,
    tickWidth: 0,
    title: {
        enabled: true,
    },
    gridLineColor: '#E3EBF6',
    tickmarkPlacement: 'on',
    tickinterval: 1,
    lineWidth: 0,
};
var yAxis = {
    offset: -10,
    gridLineColor: '#E3EBF6',
};

exports.chartType = chartType;
exports.credits = credits;
exports.goalSeries = goalSeries;
exports.legend = legend;
exports.title = title;
exports.xAxisDefaults = xAxisDefaults;
exports.yAxis = yAxis;
